/* eslint-disable react/prop-types */
/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/styles";
import { Grid, Button } from "@material-ui/core";
import {
  IsEmpty,
  getOrderItemStatusColorByStatusId,
} from "../../../../utils/helper";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    //height: "100%",
    borderRadius: 10,
    // marginBottom: 40,
    // marginTop: 50,
  },
  image: {
    border: "1px solid #E1E1E1",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: 350,
    width: "99%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
    marginTop: 5,
    width: "30%",
  },
  imgTitle: {
    fontWeight: 700,
    color: "#3f51b5",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "93%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 15,
    marginBottom: 10,
  },
  cardContent: {
    flexGrow: 1,
    padding: 10,
    overflow: "auto",
  },
  imageContainer: {
    flexGrow: 1,
    margin: 10,
  },
  imagePageNo: {
    backgroundColor: "#d9d8d8",
    fontSize: 35,
    fontWeight: 600,
    marginRight: 4,
  },
});

class OrderTab extends React.Component {

   RaiseDispute = async (event,order) => {
    
    
    window.location = "#/F302SaleOrderDisputeForm/"+order;
  };
  render() {
    const { classes } = this.props;
    let imageContainerHeight = window.screen.height - 420;

    const orderItemStatusId = IsEmpty(this.props.values.selectedSalesData)
      ? 0
      : this.props.values.selectedSalesData.statusId;

      console.log("this.props.values.selectedSalesData,",this.props.values.selectedSalesData)
    const orderId =IsEmpty(this.props.values.selectedSalesData)
      ? 0
      : this.props.values.selectedSalesData.orderId;  

    const orderItemStatusLabel = IsEmpty(this.props.values.selectedSalesData)
      ? "N/A"
      : this.props.values.selectedSalesData.statusLabel;

    const minImagesTabHeightValue =
      this.props.values.filterStatus == 13 ||
      this.props.values.filterStatus == 18 ||
      this.props.values.filterStatus == 6
        ? (64 / 100) * window.innerHeight
        : (69 / 100) * window.innerHeight;

    return (
      <React.Fragment>
        <Card className={classes.card}>
          {/* <Divider className={classes.titleDivider} /> */}
          <CardContent
            style={{
              overflow: "auto",
              maxHeight: minImagesTabHeightValue - 15,
              minHeight: minImagesTabHeightValue - 15,
              padding: 0,
            }}
          >
            <div className={classes.imageContainer}>
              {this.props.values.imagesDataLoading ? (
                <div>
                  <CircularProgress />
                </div>
              ) : (
                <Fragment>
                  {this.props.values.imagesData &&
                  this.props.values.imagesData.length > 0 ? (
                    <Fragment>
                      <Grid container spacing={1}>
                        {this.props.values.imagesData.map((card, index) => {
                          if (!card.id) {
                            return (
                              <CardContent className={classes.cardContent} />
                            );
                          } else {
                            return (
                              <Fragment key={card.id || index}>
                                <Fragment>
                                  <Grid item xs={12}>
                                    <div className={classes.imagePageNo}>
                                      {card.pageNoLabel}
                                    </div>
                                    <div
                                      onClick={() =>
                                        this.props.onImageClick(card)
                                      }
                                      className={classes.image}
                                      style={{
                                        backgroundImage: `url('${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${card.thumnailFileName}')`,
                                        height: imageContainerHeight,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Grid>
                                </Fragment>
                              </Fragment>
                            );
                          }
                        })}
                        <Grid
                          item
                          xs={12}
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <>
                          {/* Commented as per discussion with ahmed we will hide re-accept action of cancel orders*/}
                          
                            {/* {orderItemStatusId == 3 && (
                              <Button
                                style={{
                                  marginRight: 10,
                                  textTransform: "capitalize",
                                }}
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                  this.props.toggleChangeStatusDialog("card", 2)
                                }
                              >
                                {this.props.values
                                  .onConfirmItemStatusLoading ? (
                                  <CircularProgress color="primary" size={24} />
                                ) : (
                                  "Send to Confirmation Dashboard"
                                )}
                              </Button>
                            )} */}

                            {orderItemStatusId != 1 &&
                            orderItemStatusId != 13 &&
                            orderItemStatusId != 3 ? (
                            <Fragment>

                                { 
                                  orderItemStatusId==16 ? (
                                    <Button
                                      
                                      onClick={(e) =>
                                        //this.props.onImagesConfirmationClick(2)
                                        this.RaiseDispute(e,orderId)
                                      }
                                      variant="contained"
                                      color="primary"
                                    >
                                      Raise Dispute 
                                    </Button>
                                  )  :(    <Button
                                      disabled
                                      style={{
                                        cursor: "default",
                                        color:
                                          getOrderItemStatusColorByStatusId(
                                            orderItemStatusId
                                          ),
                                        border: `1px solid ${getOrderItemStatusColorByStatusId(
                                          orderItemStatusId
                                        )}`,
                                      }}
                                      variant="outlined"
                                    >
                                      {orderItemStatusLabel } 
                                    </Button>)
                                } 
                            </Fragment>    
                          

                              
                            ) : orderItemStatusId == 3 ? (
                              <Button
                            disabled
                            style={{
                              cursor: "default",
                              color:
                                getOrderItemStatusColorByStatusId(
                                  orderItemStatusId
                                ),
                              border: `1px solid ${getOrderItemStatusColorByStatusId(
                                orderItemStatusId
                              )}`,
                              marginTop: 20,
                            }}
                            variant="outlined"
                          >
                            {orderItemStatusLabel}
                          </Button>
                            ) : (
                              <Fragment>
                                {orderItemStatusId == 13 ? (
                                  <>
                                    <Button
                                      style={{
                                        marginRight: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="primary"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() =>
                                        this.props.toggleChangeStatusConfirmationDialog(
                                          11
                                        )
                                      }
                                    >
                                      {this.props.values
                                        .onConfirmItemStatusLoading ? (
                                        <CircularProgress
                                          color="primary"
                                          size={24}
                                        />
                                      ) : (
                                        `${
                                          orderItemStatusId == 13
                                            ? "Send to QA"
                                            : "Sent to QA"
                                        }`
                                      )}
                                    </Button>

                                    <Button
                                      style={{
                                        marginRight: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="primary"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() =>
                                        this.props.toggleChangeStatusConfirmationDialog(
                                          10
                                        )
                                      }
                                    >
                                      {this.props.values
                                        .onConfirmItemStatusLoading ? (
                                        <CircularProgress
                                          color="primary"
                                          size={24}
                                        />
                                      ) : (
                                        `${
                                          orderItemStatusId == 13
                                            ? "Send to Printing Dashboard"
                                            : "Sent to Printing Dashboard"
                                        }`
                                      )}
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      style={{
                                        marginRight: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="primary"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() =>
                                        //this.props.onImagesConfirmationClick(2)
                                        this.props.toggleChangeStatusDialog(
                                          "card",
                                          2
                                        )
                                      }
                                    >
                                      {this.props.values
                                        .onConfirmItemStatusLoading ? (
                                        <CircularProgress
                                          color="primary"
                                          size={24}
                                        />
                                      ) : (
                                        `${
                                          orderItemStatusId == 10
                                            ? "Accepted"
                                            : "Accept"
                                        }`
                                      )}
                                    </Button>
                                    <Button
                                      style={{
                                        marginLeft: 10,
                                        textTransform: "capitalize",
                                      }}
                                      variant="contained"
                                      color="default"
                                      disabled={
                                        this.props.values
                                          .onConfirmItemStatusLoading ||
                                        this.props.values
                                          .onCancelItemStatusLoading ||
                                        orderItemStatusId == 2 ||
                                        orderItemStatusId == 3
                                      }
                                      onClick={() =>
                                        this.props.toggleChangeStatusDialog(
                                          "card",
                                          3
                                        )
                                      }
                                    >
                                      {orderItemStatusId == 3
                                        ? "Cancelled"
                                        : "Cancel"}
                                    </Button>
                                  </>
                                )}
                              </Fragment>
                            )}
                          </>
                        </Grid>
                      </Grid>
                    </Fragment>
                  ) : (
                    orderItemStatusId == 9 && (
                      <Fragment>
                        <div>
                          <div
                            style={{
                              marginTop: 30,
                              fontSize: 16,
                              fontWeight: 600,
                            }}
                          >
                            Images not uploaded Yet !
                          </div>
                          <Button
                            disabled
                            style={{
                              cursor: "default",
                              color:
                                getOrderItemStatusColorByStatusId(
                                  orderItemStatusId
                                ),
                              border: `1px solid ${getOrderItemStatusColorByStatusId(
                                orderItemStatusId
                              )}`,
                              marginTop: 20,
                            }}
                            variant="outlined"
                          >
                            {orderItemStatusLabel}
                          </Button>
                        </div>
                      </Fragment>
                    )
                  )}
                </Fragment>
              )}
            </div>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

OrderTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  onImageClick: PropTypes.func,
  downloadImagesData: PropTypes.func,
  downloadPdfImagesData: PropTypes.func,
  printBarcode: PropTypes.func,
  onImagesConfirmationClick: PropTypes.func,
  toggleChangeStatusDialog: PropTypes.func,
};

OrderTab.defaultProps = {
  values: {},
  onImageClick: (fn) => fn,
  downloadImagesData: (fn) => fn,
  downloadPdfImagesData: (fn) => fn,
  onImagesConfirmationClick: (fn) => fn,
  printBarcode: (fn) => fn,
  toggleChangeStatusDialog: (fn) => fn,
};

export default withStyles(useStyles)(OrderTab);
